import WaitingDots from "components/WaitingDots";
import React, { useEffect, useState } from "react";
import { Alert } from "reactstrap";
import { activateMFA, checkMFA } from "../../../services/AccountApi";
import DeleteMfa from "./DeleteMfa";
import { useAccountTranslation } from "../translations";

const MfaQr: React.FC = () => {
    const [step, setStep] = useState<"loading" | "scan" | "verify" | "active" | "activated" | "deactivate">("loading");
    const [mfaQr, setMfaQr] = useState<string>();
    const [otp, setOtp] = useState("");
    const [error, setError] = useState<string | null>(null);
    const { t } = useAccountTranslation();

    useEffect(() => {
        checkMFA()
            .then(code => {
                // @ts-ignore legacy endpoint response
                setMfaQr(code.mfa_qr);
                setStep("scan");
            })
            .catch(() => setStep("active"));
    }, []);

    if (step === "loading") {
        return <div className="portal-settings-loading"><WaitingDots /></div>;
    }

    if (step === "active" || step === "activated") {
        return <div className="portal-setting-control">
            <div className="portal-setting-status portal-setting-status--enabled">
                <span><i className="mdi mdi-shield-check-outline" /></span>
                <div>
                    <strong>{step === "activated" ? t("mfaActivated") : t("mfaAlreadyActive")}</strong>
                    <small>{t("securityDescription")}</small>
                </div>
            </div>
            {step === "active" && <button
                type="button"
                className="portal-button portal-button-danger"
                onClick={() => setStep("deactivate")}
            >
                {t("deactivateMfa")}
            </button>}
        </div>;
    }

    if (step === "deactivate") {
        return <div className="portal-mfa-deactivate">
            <DeleteMfa
                setMfaSetUp={value => setStep(value === 1 ? "scan" : value === 3 ? "active" : "deactivate")}
                setMfaQr={setMfaQr}
            />
        </div>;
    }

    const verify = () => {
        setError(null);
        activateMFA({ totp: otp })
            .then(() => setStep("activated"))
            .catch(() => setError(t("mfaOtpError")));
    };

    return <div className="portal-mfa-setup">
        <div className="portal-mfa-steps" aria-label={t("setUpMfa")}>
            <span className="portal-mfa-step portal-mfa-step--active"><b>1</b>{t("mfaDownloadApp")}</span>
            <span className={step === "verify" ? "portal-mfa-step portal-mfa-step--active" : "portal-mfa-step"}><b>2</b>{t("mfaScanCode")}</span>
            <span className="portal-mfa-step"><b>3</b>{t("mfaConfirmCode")}</span>
        </div>

        {step === "scan" && <div className="portal-mfa-scan">
            <div className="portal-mfa-copy">
                <strong>{t("mfaScanTitle")}</strong>
                <p>{t("mfaScanDescription")}</p>
                <small><i className="mdi mdi-information-outline" />{t("mfaTip")}</small>
            </div>
            {mfaQr && <div className="portal-mfa-qr">
                <img src={`data:image/png;base64,${mfaQr}`} alt={t("qrCode")} />
            </div>}
            <button type="button" className="portal-button portal-button-primary" onClick={() => setStep("verify")}>
                {t("scanned")}<i className="mdi mdi-arrow-right" />
            </button>
        </div>}

        {step === "verify" && <div className="portal-mfa-verify">
            <div>
                <strong>{t("mfaConfirmTitle")}</strong>
                <p>{t("mfaConfirmDescription")}</p>
            </div>
            {error && <Alert color="danger">{error}</Alert>}
            <label htmlFor="account-mfa-otp">{t("otp")}</label>
            <div className="portal-mfa-input-row">
                <input
                    id="account-mfa-otp"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    value={otp}
                    onChange={event => setOtp(event.target.value)}
                    placeholder="123456"
                />
                <button
                    type="button"
                    className="portal-button portal-button-primary"
                    disabled={!otp.trim()}
                    onClick={verify}
                >
                    {t("confirm")}
                </button>
            </div>
        </div>}
    </div>;
};

export default MfaQr;
